export const findConfigNodeByCode = (airports, code) => airports.reduce((accumulator, node) => {
  if (node.code === code) {
    return node;
  }
  if (accumulator) return accumulator;
  if (node.children) {
    return findConfigNodeByCode(node.children, code);
  }
  return accumulator;
}, null);
export const retrieveCodes = (airports, code) => {
  const node = findConfigNodeByCode(airports, code);
  if (!node) {
    return null;
  }
  if (node.children && node.children.length > 0) {
    return node.children?.reduce((accumulator, {
      airports
    }) => {
      if (airports) {
        return [...accumulator, ...airports.map(({
          code
        }) => code)];
      }
      return accumulator;
    }, []);
  }
  if (node.airports) {
    return node.airports.map(({
      code
    }) => code);
  }
  return null;
};
const findDefaultNode = airports => airports.find(({
  default: isDefault
}) => isDefault);
export const retrieveDefaultCodes = airports => {
  const node = findDefaultNode(airports);
  if (node) {
    return retrieveCodes(airports, node.code) || [];
  }
  return [];
};